import moment from 'moment';

function getListeByDate(ots) {
  const listFilteredByDate = [];
  const dates = [...new Set(ots.map(ot => ot.datePlanification))];
  dates.forEach((date) => {
    const otsParDate = ots.filter(ot => ot.datePlanification === date);
    listFilteredByDate.push({
      datePlanification: date,
      isOpen: false,
      selected: false,
      nbOts: otsParDate.length,
      ots: otsParDate.map((ot) => {
        return {
          id: ot.id,
          code: ot.code,
          typeOtId: ot.typeOtId,
          etat: ot.etat,
          ville: ot.otPatrimoine ? ot.otPatrimoine.adresse.ville : null,
        };
      }),
    });
  });
  return listFilteredByDate.sort((a, b) => {
    if (moment(a.datePlanification).isBefore(moment(b.datePlanification))) return -1;
    return moment(a.datePlanification).isAfter(moment(b.datePlanification)) ? 1 : 0;
  });
}

export default function formatageRessourceListe(ots) {
  const ressourceList = [];
  const idsTechnicien = [...new Set(ots
    .filter(o => !!o.fournisseurId)
    .map(o => o.fournisseurId))];
  idsTechnicien.forEach((technicienId) => {
    const otsFilter = ots.filter(o => o.fournisseurId === technicienId);
    ressourceList.push({
      technicienId: technicienId,
      technicien: otsFilter[0].fournisseur.nomCommercial,
      nbOts: otsFilter.length,
      isOpen: false,
      dateList: getListeByDate(otsFilter),
    });
  });
  return ressourceList.sort((a, b) => {
    return a.technicien.localeCompare(b.technicien);
  });
}
